import React from 'react';

const flag = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3 2">
    <rect width="3" height="2" fill="#000000" />
  </svg>
);

export default flag;
